import bitObjectSystem from "./systems/bit-object-system";
import { cubeSystem } from "./systems/cubeSystem";
import { rpmSystem } from "./systems/rpmSystem";
import { World } from "./threeMain";

export function prepareSystems(world: World){
  world.mainSystem.addSystem(bitObjectSystem, "prerender")
  world.mainSystem.addSystem(cubeSystem, "prerender")
  world.mainSystem.addSystem(rpmSystem, "prerender")
}